import { buildClientHeaderValue, toBuildSha } from '@/utils/clientHeader';

/**
 * `x-client` value of this build: `partners/<package.json version>[+<short git SHA>]`. The version is
 * injected by `vite.config.ts` (`VITE_APP_VERSION`); the SHA comes from `VITE_APP_RELEASE`, which
 * `scripts/deploy.sh` exports. Local runs and tests send `partners/<version>` or `partners/0.0.0`.
 */
export const CLIENT_HEADER_VALUE = buildClientHeaderValue({
  name: 'partners',
  version: import.meta.env.VITE_APP_VERSION,
  build: toBuildSha(import.meta.env.VITE_APP_RELEASE),
});
